import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

// @ts-prune-ignore-next
export const SOLUTION_DID_NOT_HELP = (
  strictLocalize: StrictLocalizeFunction
) => {
  return {
    id: "SOLUTION_DID_NOT_HELP",
    label: strictLocalize({
      defaultMessage: "Didn't help solve issue",
      description: {
        text: "One of the reasons for a low CSAT score in our help center",
        img: "https://cdn.faire.com/fastly/fcf3c31b3c258208fe766b50695e3fe8b745477b0b851f3fa9224512c445fb8e.png",
      },
    }),
  };
};

const SOLUTION_CONFUSING_OR_UNCLEAR = (
  strictLocalize: StrictLocalizeFunction
) => {
  return {
    id: "SOLUTION_CONFUSING_OR_UNCLEAR",
    label: strictLocalize({
      defaultMessage: "Confusing or unclear",
      description: {
        text: "One of the reasons for a low CSAT score in our help center",
        img: "https://cdn.faire.com/fastly/fcf3c31b3c258208fe766b50695e3fe8b745477b0b851f3fa9224512c445fb8e.png",
      },
    }),
  };
};

const SOLUTION_NOT_RELEVANT = (strictLocalize: StrictLocalizeFunction) => {
  return {
    id: "SOLUTION_NOT_RELEVANT",
    label: strictLocalize({
      defaultMessage: "Not relevant",
      description: {
        text: "One of the reasons for a low CSAT score in our help center",
        img: "https://cdn.faire.com/fastly/fcf3c31b3c258208fe766b50695e3fe8b745477b0b851f3fa9224512c445fb8e.png",
      },
    }),
  };
};

export const OTHER_REASON = (strictLocalize: StrictLocalizeFunction) => {
  return {
    id: "OTHER_REASON",
    label: strictLocalize({
      defaultMessage: "Other",
      description: {
        text: "One of the reasons for a low CSAT score in our help center",
        img: "https://cdn.faire.com/fastly/fcf3c31b3c258208fe766b50695e3fe8b745477b0b851f3fa9224512c445fb8e.png",
      },
    }),
  };
};

export const CSAT_REASONS = (strictLocalize: StrictLocalizeFunction) => [
  SOLUTION_DID_NOT_HELP(strictLocalize),
  SOLUTION_CONFUSING_OR_UNCLEAR(strictLocalize),
  SOLUTION_NOT_RELEVANT(strictLocalize),
  OTHER_REASON(strictLocalize),
];
